var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkinline = function SvgNetworkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.996 18.356a4.355 4.355 0 1 0 0-8.711 4.355 4.355 0 0 0 0 8.71M14.005 4.667a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "M14.008 2.334v5.444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.995 23.333a2.333 2.333 0 1 0 0 4.667 2.333 2.333 0 0 0 0-4.667"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "M13.992 25.668v-5.444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.333 14A2.333 2.333 0 1 0 28 14a2.333 2.333 0 0 0-4.667 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "M25.664 13.998H20.22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.667 14A2.333 2.333 0 1 0 0 14a2.333 2.333 0 0 0 4.667 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "M2.336 14.002H7.78"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.592 7.4a2.333 2.333 0 1 0 3.3-3.299 2.333 2.333 0 0 0-3.3 3.3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "m22.242 5.752-3.85 3.85"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 20.6a2.333 2.333 0 1 0-3.3 3.299 2.333 2.333 0 0 0 3.3-3.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "m5.75 22.248 3.85-3.85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.605 20.6a2.333 2.333 0 1 0 3.3 3.3 2.333 2.333 0 0 0-3.3-3.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "m22.258 22.25-3.85-3.85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.395 7.398a2.333 2.333 0 1 0-3.3-3.3 2.333 2.333 0 0 0 3.3 3.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.902,
    d: "m5.742 5.748 3.85 3.85"
  })));
};
export default SvgNetworkinline;